// API configuration for Platform.IdentityServer backend
export interface ApiConfig {
  baseUrl: string;
  timeout: number;
}

// Default API configuration - should be overridden by environment variables
const defaultApiConfig: ApiConfig = {
  baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5007',
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '10000', 10)
};

// Validate API configuration
const validateApiConfig = (config: ApiConfig): void => {
  if (!config.baseUrl) {
    throw new Error(
      'Missing API base URL. Please set REACT_APP_API_BASE_URL environment variable.'
    );
  }

  if (config.timeout <= 0) {
    throw new Error('API timeout must be a positive number.');
  }
};

// Validate configuration
validateApiConfig(defaultApiConfig);

export const apiConfig = defaultApiConfig;
export default apiConfig;